<template>
  <div
    v-if="!item.hidden"
    class="mes-menu-item">
    <template
      v-if="hasOneChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noChildren) && !item.alwaysShow">
      <mes-link
        v-if="onlyOneChild.meta"
        :to="resolvePath(onlyOneChild.path)"
        :query="onlyOneChild.meta.redirect">
        <el-menu-item :index="resolvePath(onlyOneChild.path)">
          <i
            v-if="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :class="onlyOneChild.meta.icon || item.meta.icon">
          </i>
          <span slot="title">{{ onlyOneChild.meta.title }}</span>
        </el-menu-item>
      </mes-link>
    </template>
    <el-submenu v-else :index="resolvePath(item.path)">
      <template slot="title">
        <i v-if="item.meta && item.meta.icon" :class="item.meta.icon"></i>
        <span>{{ item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(child.path)"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path';
import MesLink from './link';
import { isExternal } from '@/utils/validate';

export default {
  name: 'SidebarItem',
  components: {
    MesLink
  },
  props: {
    item: { // 数据
      type: Object,
      required: true
    },
    basePath: { // 基本路径
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null;
    return {};
  },
  methods: {
    // 只有一个菜单
    hasOneChild(children = [], parent) {
      const childList = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          this.onlyOneChild = item;
          return true;
        }
      });
      if (childList.length === 1) {
        return true;
      }
      if (childList.length === 0) {
        this.onlyOneChild = {
          ... parent,
          path: '',
          noChildren: true
        };
        return true;
      }
      return false;
    },
    // 解析路径
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    }
  }
};
</script>